import { useState, Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import ArrowIcon from '../Icons/ArrowIcon';

export interface option {
    id?: string;
    name: string;
    code?: string;
    discount?: string | number | boolean;
}

interface SelectboxProps {
    title?: string;
    name?: string;
    value?: string;
    className?: string;
    selectOptions: option[];
    placeholder?: string;
    titleStyles?: string;
    setSelected?: React.Dispatch<React.SetStateAction<option[]>>;
    selected?: option[];
}

const MultiSelectbox = ({ title, className, selectOptions, name, value, placeholder, selected, setSelected, titleStyles }: SelectboxProps) => {
    const [selectedOptions, setSelectedOptions] = useState<option[]>(selected || []);

    const handleChange = (options: option[]) => {
        setSelectedOptions(options);
        setSelected && setSelected(options);
    };

    return (
        <Listbox name={name} value={value || selectedOptions} onChange={handleChange} multiple>
            <div className="relative w-full">
                {title && <h1 className={`mb-2 text-sm font-semibold text-textPrimary ${titleStyles}`}>{title}</h1>}
                <Listbox.Button className={`relative block h-14 w-full rounded-xl border border-[#d8e0df] bg-[#f8faf9] px-4 py-3 text-left text-sm font-medium text-textPrimary transition-all duration-200 hover:border-secondary/50 focus:border-secondary focus:bg-white focus:outline-none focus:ring-4 focus:ring-secondary/10 ${className}`}>
                    <span className="block truncate">{selectedOptions.length > 0 ? selectedOptions.map((option) => option.name).join(', ') : placeholder}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-lightGray">
                        <ArrowIcon className='h-4 w-5 rotate-[270deg]' />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Listbox.Options className="absolute z-[9999] mt-2 max-h-60 w-full overflow-auto rounded-xl border border-black/10 bg-white p-1 text-base shadow-[0_18px_55px_rgba(17,24,22,0.16)] focus:outline-none sm:text-sm">
                        {selectOptions.map((option) => (
                            <Listbox.Option
                                className={({ active }) => `relative cursor-default select-none rounded-lg py-2.5 pl-10 pr-4 text-textPrimary ${active ? "bg-secondary/10 text-primary" : ""}`}
                                key={option.id}
                                value={option}
                            >
                                <span className={`block text-sm truncate`}>
                                    {option.name}
                                </span>
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    );
};

export default MultiSelectbox;
